import React, { Component } from 'react';
import styled from 'styled-components';

export interface IFormProps {
  minWidth?: string;
}

const FormContainerStyled = styled.form`
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 15px;
`;

export const PageForm: React.FC<any> = props => {
  return <FormContainerStyled {...props}>{props.children}</FormContainerStyled>;
};

export default PageForm;
